import React, { Component } from "react";
import withFilterOptions from "../hocs/withFilterOptions";
import withItems from "../hocs/withItems";
import { Select, Spin } from "antd";
import { getAttribute } from "../utils/models";
import Format from "../containers/Format";
import FormItem from "./FormItem";
import withHandleSearch from "../hocs/withHandleSearch";
import _ from "lodash";

const Option = Select.Option;

class Model extends Component {
  getChargeTypeItems = ({ dispatch, items }) => {
    if (dispatch.supplier.sapId) {
      let indicator = "FS";

      if (dispatch.supplier.sapId === "50021") indicator = "FP";

      items = _.filter(items, item => item.indicator === indicator);
    }

    return items;
  };

  render() {
    let { items } = this.props;
    const { getFieldDecorator } = this.props.form;
    const attribute = getAttribute(this.props.model, this.props.attribute);

    if (this.props.model === "charge" && !this.props.fetching) {
      items = this.getChargeTypeItems(this.props);
    }
    return (
      <FormItem {...this.props}>
        {getFieldDecorator(this.props.attribute, {
          ...this.props.fieldSettings
        })(
          <Select
            size="large"
            disabled={this.props.disabled}
            style={{ width: "100%" }}
            loading={this.props.fetching}
            allowClear={!attribute.required}
            onSearch={this.props.handleSearch}
            onChange={this.props.handleChange}
            filterOption={this.props.filterOption}
            showSearch
            placeholder={this.props.placeholder}
            notFoundContent={this.props.fetching ? <Spin size="small" /> : null}
          >
            {items.map((item, index) => {
              const fullValue = this.props.needFullValue
                ? JSON.stringify({
                    id: item.id,
                    lat: item.lat,
                    lng: item.lng,
                    ...item
                  })
                : null;
              return (
                <Option
                  key={index}
                  value={fullValue ? fullValue : item.id || item}
                >
                  <Format
                    model={this.props.model}
                    attribute={this.props.attribute}
                    value={item}
                  />
                </Option>
              );
            })}
          </Select>
        )}
      </FormItem>
    );
  }
}

export default withHandleSearch(withFilterOptions(withItems(Model)));



// WEBPACK FOOTER //
// ./src/inputs/Model.js